import { Theme } from '@mui/material';

import config from '@shared/config';


const Button = (theme: Theme) => {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: config.theme.disableRipple,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: config.theme.elevation === 0,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          position: 'relative',
        },
      },
      variants: [{
        props: { variant: 'contained' },
        style: {
          borderColor: '#000',
          borderStyle: 'solid',
          borderWidth: 2,
          boxShadow: '-5px 5px 0 #000',
        },
      }],
    },
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: config.theme.elevation === 0,
      },
    },
  };
};

export default Button;
